var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{class:'mt-' +
    _vm.mTop +
    ' ' +
    (_vm.$vuetify.breakpoint.xsOnly ? 'rounded-0 elevation-0' : 'depth-1')},[_c('v-card-text',{staticClass:"py-0"},[_c('div',{staticStyle:{"position":"relative"}},[_vm._t("default")],2)]),_c('v-card-title',[_vm._v("   ")]),_vm._t("a")],2)}
var staticRenderFns = []

export { render, staticRenderFns }